import { all, call, put, takeLatest } from "redux-saga/effects";

import Schemas from "../models";
import actions from "../../constants/actions";
import { POST } from "../../utils/api";

function _buildFormData(formData, data, parentKey) {
    if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
    ) {
        Object.keys(data).forEach((key) => {
            _buildFormData(
                formData,
                data[key],
                parentKey ? `${parentKey}[${key}]` : key
            );
        });
    } else {
        const value = data == null ? "" : data;

        formData.append(parentKey, value);
    }
}

export function* login(data) {
    try {
        let response = yield call(POST, {
            url: "login",
            data: {
                email: data.payload.email,
                password: data.payload.password,
                remember: true,
            },
            schema: Schemas.USER,
        });

        yield put({ type: actions.LOGIN_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.LOGIN_FAIL, payload: error });
    }
}

export function* register({ payload }) {
    let formData = new FormData();
    _buildFormData(formData, payload.data);

    try {
        let response = yield call(POST, {
            url: "register",
            data: formData,
            schema: Schemas.USER,
        });

        yield put({ type: actions.REGISTER_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.REGISTER_FAIL, payload: error });
    }
}

export function* recover({ payload }) {
    try {
        yield call(POST, {
            url: "password/email",
            data: {
                email: payload.email,
            },
        });

        yield put({ type: actions.RECOVER_SUCCESS });
    } catch (error) {
        yield put({ type: actions.RECOVER_FAIL, payload: error });
    }
}

export function* logout() {
    try {
        let response = yield call(POST, {
            url: "logout",
        });

        yield put({ type: actions.LOGOUT_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.LOGOUT_FAIL, payload: error });
    }
}

export function* reset({ payload }) {
    try {
        let response = yield call(POST, {
            url: "password/reset",
            data: {
                email: payload.email,
                password: payload.password,
                password_confirmation: payload.password,
                token: payload.token,
            },
            schema: Schemas.USER,
        });

        yield put({ type: actions.RESET_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.RESET_FAIL, payload: error });
    }
}

export default function* Auth() {
    yield all([
        yield takeLatest(actions.LOGIN, login),
        yield takeLatest(actions.REGISTER, register),
        yield takeLatest(actions.RECOVER, recover),
        yield takeLatest(actions.LOGOUT, logout),
        yield takeLatest(actions.RESET, reset),
    ]);
}
